import * as React from 'react';

interface ICardContentProps {
	isHidden?: boolean;
}

export default class CardContent extends React.Component<
	ICardContentProps,
	{}
> {
	public render() {
		if (this.props.isHidden) {
			return null;
		}

		return <div className="card-content">{this.props.children}</div>;
	}
}
